import { gql } from '@apollo/client';

export const SEARCH_SELECT_LIST = gql`
  query SearchSelectLists($searchInput: SearchInput) {
    searchSelectLists(searchInput: $searchInput) {
      items {
        id
        name
        projectId
        selectMetadataColumns {
          id
          name
          memberName
          columnHeading
          decimals
          dataType
          alternateColumnHeading
        }
      }
    }
  }
`;

export const GET_SELECT_LIST_DATA = gql`
  query GetSelectListData($name: String!, $searchInput: SearchInput) {
    getSelectListData(name: $name, searchInput: $searchInput) {
      items {
        column1
        column2
        column3
        column4
        column5
        column6
      }
    }
  }
`;
